import React, { memo, useRef } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import "../Classroom/styles.scss";

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <div
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </div>
));

const iconTextStyles = {
  textDecoration: "none",
  color: "#4E5566",
  fontFamily: "Plus Jakarta Sans",
  fontSize: "14px",
  fontWeight: "400",
  textAlign: "left",
  lineHeight: "22px",
};

const MenuComponent = ({ children, list, passedData, filterIndex = null }) => {
  const dropdownRef = useRef(null);

  return (
    <Dropdown ref={dropdownRef}>
      <Dropdown.Toggle
        id="dropdown-basic"
        as={CustomToggle}
        ref={dropdownRef}
        className="transparent-dropdown-toggle"
      >
        {children}
      </Dropdown.Toggle>

      <Dropdown.Menu style={{ padding: "12px 0px 12px 0px" }}>
        {list.map((option) => {
          return (
            <Dropdown.Item
              onClick={() => {
                option?.actionsHandler(passedData, option?.type, filterIndex);
              }}
              style={{ padding: "0px" }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "5px 18px 5px 18px",
                }}
              >
                <span style={iconTextStyles}>{option?.text}</span>
              </div>
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default memo(MenuComponent);
